import type { ImportedStickerRow } from '../shared/domain'
import { parseStickerCsv } from '../shared/importer'
import { parseSpreadsheetMatrices, type SpreadsheetCell, type SpreadsheetImportFormat } from '../shared/spreadsheet-importer'

export type ParsedImportFile = {
  bytes: ArrayBuffer
  rows: ImportedStickerRow[]
  format: 'csv' | SpreadsheetImportFormat
  reviewCount: number
  sheetName?: string
}

export async function parseImportFile(file: File): Promise<ParsedImportFile> {
  if (file.size > 15 * 1024 * 1024) throw new Error('O arquivo deve ter no máximo 15 MB')
  const bytes = await file.arrayBuffer()
  const extension = file.name.split('.').at(-1)?.toLowerCase()
  if (extension === 'csv' || file.type.includes('csv')) {
    const text = new TextDecoder('utf-8').decode(bytes)
    return { bytes, rows: parseStickerCsv(text), format: 'csv', reviewCount: 0 }
  }
  if (!['xlsx', 'xls'].includes(extension ?? '')) throw new Error('Use um arquivo CSV, XLSX ou XLS')

  const { read, utils } = await import('xlsx')
  const workbook = read(bytes, { type: 'array', cellDates: true })
  const parsed = parseSpreadsheetMatrices(workbook.SheetNames.map((name) => ({
    name,
    rows: utils.sheet_to_json<SpreadsheetCell[]>(workbook.Sheets[name], {
      header: 1,
      raw: true,
      defval: null,
      blankrows: false,
    }),
  })))
  return { bytes, ...parsed }
}
